import { Conditions } from '../constants/conditions'
import parse from 'date-fns/parse'
import format from 'date-fns/format'
import { CheckConditionName, RadioConditionName } from '../actions'

export type QueryKey =
  | 'shareholderStatus'
  | 'totalFundingFrom'
  | 'totalFundingTo'
  | 'valuationFrom'
  | 'valuationTo'
  | 'origin'
  | 'ipoCategory'
  | 'establishedFrom'
  | 'establishedTo'
  | 'ipoedFrom'
  | 'ipoedTo'
  | 'lastFundraisedFrom'
  | 'lastFundraisedTo'
  | 'type'
  | 'employeesFrom'
  | 'employeesTo'
  | 'shareholderStatus'
  | 'page'

export type QueryObject = {
  [key in QueryKey]?: string
}
export function queriesOf(selected: Conditions): QueryObject {
  let obj = {}
  const {
    totalFunding,
    valuation,
    employees,
    established,
    ipoed,
    lastFundraised,
    ...rest
  } = selected
  if (totalFunding) {
    const { from: totalFundingFrom, to: totalFundingTo } = totalFunding
    Object.assign(obj, { totalFundingFrom, totalFundingTo })
  }
  if (valuation) {
    const { from: valuationFrom, to: valuationTo } = valuation
    Object.assign(obj, { valuationFrom, valuationTo })
  }
  if (employees) {
    const { from: employeesFrom, to: employeesTo } = employees
    Object.assign(obj, { employeesFrom, employeesTo })
  }
  if (established) {
    const { from: establishedFrom, to: establishedTo } = established
    Object.assign(obj, {
      establishedFrom: establishedFrom ? normalize(establishedFrom) : null,
      establishedTo: establishedTo ? normalize(establishedTo) : null,
    })
  }
  if (ipoed) {
    const { from: ipoedFrom, to: ipoedTo } = ipoed
    Object.assign(obj, {
      ipoedFrom: ipoedFrom ? normalize(ipoedFrom) : null,
      ipoedTo: ipoedTo ? normalize(ipoedTo) : null,
    })
  }
  if (lastFundraised) {
    const { from: lastFundraisedFrom, to: lastFundraisedTo } = lastFundraised
    Object.assign(obj, {
      lastFundraisedFrom: lastFundraisedFrom
        ? normalize(lastFundraisedFrom)
        : null,
      lastFundraisedTo: lastFundraisedTo ? normalize(lastFundraisedTo) : null,
    })
  }
  for (const item in rest) {
    const selectedItem =
      selected[item as CheckConditionName | RadioConditionName]
    selectedItem && Object.assign(obj, { [item]: selectedItem.join(',') })
  }
  return obj
}
export const normalize = (date: string): string =>
  format(parse(date, 'yyyy-MM-dd', new Date()), 'yyyy-MM-dd')
